import { createDeferredCatalogue } from '../components/form/DeferredCatalogueStep';

// Keep the router and its submission state mounted while loading/retrying.
// Retrying this code download never calls the submission handler again.
const confirmation = createDeferredCatalogue({
  confirmation: () => import('./ThankYou'),
});

export default function DeferredThankYou() {
  const Confirmation = confirmation.Step;
  return <Confirmation type="confirmation" />;
}
